import homeShadowIcon from "../../../../../assets/themeIcons/shadow-home.svg";
import heartShadowIcon from "../../../../../assets/themeIcons/shadow-heart.svg";
function NextBestActionsCard({ activities }) {
  return (
    <>
      <section className="sd-card" style={{ maxHeight: "500px", overflowY: "auto" }}>
        <h3 className="sd-section-title">Recent Activities</h3>
        <div className="sd-actions">
          {activities?.map((item) => (
            <div className="sd-actions__row" key={item?._id}>
              <div
                style={{
                  width: 40,
                  height: 40,
                }}
              >
                <img
                  style={{ verticalAlign: "sub" }}
                  width={"40px"}
                  src={item?.type === "business" ? homeShadowIcon : heartShadowIcon}
                />
              </div>
              <p>{item?.activity}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}

export default NextBestActionsCard;
